import React from 'react';

import BaseCell from '../BaseCell';
import StatusPill from '../../../StatusPill';
import type { StatusPillOption, StatusPillPaletteId } from '../../../StatusPill';

export interface StatusPillCellProps {
  palette: StatusPillPaletteId;
  label: string;
  size?: 'sm' | 'md' | 'lg';
  /** When set with onOptionSelect, renders editable StatusPill with dropdown (same menu as StatusPill). */
  options?: StatusPillOption[];
  onOptionSelect?: (option: StatusPillOption) => void;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const StatusPillCell: React.FC<StatusPillCellProps> = ({
  palette,
  label,
  size = 'md',
  options,
  onOptionSelect,
  isOpen,
  onOpenChange
}) => {
  const isEditable = options != null && onOptionSelect != null;

  if (isEditable) {
    const stopRowClick = (e: React.MouseEvent) => {
      e.stopPropagation();
    };
    return (
      <BaseCell overflowVisible>
        <div role="presentation" onClick={stopRowClick} onMouseDown={stopRowClick}>
          <StatusPill
            palette={palette}
            label={label}
            size={size}
            editable
            options={options}
            onOptionSelect={onOptionSelect}
            isOpen={isOpen}
            onOpenChange={onOpenChange}
          />
        </div>
      </BaseCell>
    );
  }

  return (
    <BaseCell>
      <StatusPill palette={palette} label={label} size={size} />
    </BaseCell>
  );
};

export default StatusPillCell;
